export enum Method {
  POST = "POST",
  GET = "GET",
  PUT = "PUT",
  DELETE = "DELETE",
  PATCH = "PATCH",
}

export enum TAG {
  NOTES = "NOTES",
  LABEL = "LABEL",
}
